// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.thirdweb",
    name: "thirdweb",
    homepage: "https://thirdweb.com",
    image_id: "c8d820ec-54fb-4c0e-210e-5cbbf92e1000",
    app: {
        browser: "https://thirdweb.com",
        ios: null,
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://ews.thirdweb.com",
    },
    desktop: {
        native: null,
        universal: "https://ews.thirdweb.com",
    },
};
//# sourceMappingURL=index.js.map